import React from "react";
import { useBranding } from "../context/BrandingContext";

const ICON = `${process.env.PUBLIC_URL || ""}/brand/logo-icon.png`;
const FULL = `${process.env.PUBLIC_URL || ""}/brand/central-flow-logo.png`;

export function BrandIcon({ size = 40, className = "", rounded = "rounded-xl" }) {
  const { appLogo } = useBranding();
  return (
    <img
      src={appLogo || ICON}
      alt="logo"
      className={`${rounded} object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function BrandWordmark({ className = "", tone = "dark" }) {
  const { companyName } = useBranding();
  const name = (companyName || "Central Flow").trim();
  const parts = name.split(/\s+/);
  const first = parts[0];
  const rest = parts.slice(1).join(" ");
  const firstColor = tone === "light" ? "text-white" : "text-ink";
  return (
    <span className={`font-heading font-extrabold tracking-tight ${className}`}>
      <span className={firstColor}>{first}</span>
      {rest && <span className="text-primary"> {rest}</span>}
    </span>
  );
}

export function BrandLockup({ iconSize = 40, subtitle, className = "", textClass = "text-lg" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <BrandIcon size={iconSize} />
      <div className="leading-tight">
        <BrandWordmark className={textClass} />
        {subtitle && <p className="text-[11px] font-semibold text-ink-mute">{subtitle}</p>}
      </div>
    </div>
  );
}

export function BrandFull({ className = "", style }) {
  const { appLogo } = useBranding();
  return <img src={appLogo || FULL} alt="logo" className={className} style={style} />;
}
